import { BookOpen, Globe, Rocket, TrendingUp, CheckCircle } from "lucide-react";
import TimelineItem from "./TimelineItem";

const milestones = [
    {
      year: "2022",
      label: "Began our journey in real estate advisory and launched National Property Consultant",
      icon: BookOpen,
    },
    {
      year: "2023",
      label: "Established a trusted agent network and supported investors across Australia",
      icon: Globe,
    },
    {
      year: "2024",
      label: "Expanded nationwide with stronger systems and strategic partnerships",
      icon: Rocket,
    },
    {
      year: "2025",
      label: "Continued helped clients acquire high-performing investment properties",
      icon: TrendingUp,
    },
    {
      year: "2025",
      label: "Developed and launched propsourcing.com.au — our proprietary sourcing platform",
      icon: CheckCircle,
    },
  ];
  
  

const TimelineSection = () => (
  <section className="bg-white py-20 px-6">
    <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold text-center text-[#003366] mb-10">Our Journey</h2>
      <div className="border-l-4 border-[#fbb40b] pl-4 space-y-10">
        {milestones.map((m, index) => (
          <TimelineItem key={index} {...m} />
        ))}
      </div>
    </div>
  </section>
);

export default TimelineSection;
